/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconAmex from '@telus-uds/palette-public-mobile/build/rn/icons/Amex'
import PaletteIconEyeUnmasked from '@telus-uds/palette-public-mobile/build/rn/icons/EyeUnmasked'
import PaletteIconCreditCard from '@telus-uds/palette-public-mobile/build/rn/icons/CreditCard'
import PaletteIconMasterCard from '@telus-uds/palette-public-mobile/build/rn/icons/MasterCard'
import PaletteIconEyeMasked from '@telus-uds/palette-public-mobile/build/rn/icons/EyeMasked'
import PaletteIconVisa from '@telus-uds/palette-public-mobile/build/rn/icons/Visa'
import PaletteIconCheckMark from '@telus-uds/palette-public-mobile/build/rn/icons/CheckMark'
import PaletteIconXMarkCircle from '@telus-uds/palette-public-mobile/build/rn/icons/XMarkCircle'
const theme = {
  appearances: {
    focus: {
      description: 'Focus states for some input elements are well supported across web, RN, ios and android',
      type: 'state',
      values: [ true ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    numeric: {
      description: 'capability to only allow numbers',
      type: 'variant',
      values: [ true ]
    },
    password: {
      description: 'password mask and unmask',
      type: 'variant',
      values: [ true ]
    },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning' ]
    }
  },
  rules: [
    {
      if: { hover: true, inactive: null },
      tokens: {
        outerBackgroundColor: '#cdcfd5',
        outerBorderColor: '#cdcfd5',
        outerBorderWidth: 1
      }
    },
    {
      if: { validation: 'success' },
      tokens: {
        borderColor: '#2b826e',
        icon: PaletteIconCheckMark,
        iconColor: '#2b826e'
      }
    },
    {
      if: { validation: 'error' },
      tokens: {
        borderColor: '#bf1722',
        icon: PaletteIconXMarkCircle,
        iconColor: '#bf1722'
      }
    },
    {
      if: { focus: true },
      tokens: {
        icon: null,
        outerBackgroundColor: '#f39d80',
        outerBorderColor: '#f39d80',
        outerBorderWidth: 2
      }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#cdcfd5',
        borderColor: '#cdcfd5',
        color: '#9c9faa'
      }
    }
  ],
  tokens: {
    amexIcon: PaletteIconAmex,
    backgroundColor: '#ffffff',
    borderColor: '#394056',
    borderRadius: 4,
    borderWidth: 1,
    buttonSize: 32,
    buttonsGap: 1,
    buttonsPaddingRight: 10,
    clearButtonIcon: PaletteIconEyeUnmasked,
    color: '#394056',
    defaultCreditIcon: PaletteIconCreditCard,
    fontName: 'SofiaPro',
    fontSize: 16,
    fontWeight: '400',
    icon: null,
    iconColor: 'rgba(0, 0, 0, 0)',
    iconLeftGap: 5,
    iconLeftPaddingBottom: 5,
    iconSize: 24,
    leftIconPaddingBottom: 5,
    lineHeight: 1.5,
    masterCardIcon: PaletteIconMasterCard,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderWidth: 2,
    paddingBottom: 10,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 10,
    passwordHideButtonIcon: PaletteIconEyeMasked,
    passwordShowButtonIcon: PaletteIconEyeUnmasked,
    visaIcon: PaletteIconVisa
  }
}
export default theme
